import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// ============================================================
// Firebase Configuration
// ============================================================
// Initialize Firebase with your project config from Firebase Console
// Get these values from: https://console.firebase.google.com/project/{project}/settings/general

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase (may fail if env vars are missing, e.g. Dependabot PRs)
let app;
try { app = initializeApp(firebaseConfig); } catch { /* Firebase unavailable */ }

// Initialize services (each may fail if app init failed or config is invalid)
let auth, db, storage, analytics;
try { auth = getAuth(app); } catch { /* auth unavailable */ }
try { db = getFirestore(app); } catch { /* firestore unavailable */ }
try { storage = getStorage(app); } catch { /* storage unavailable */ }
try { analytics = getAnalytics(app); } catch { /* analytics unavailable */ }

// ============================================================
// Development: Connect to Firebase Emulator Suite
// ============================================================
if (import.meta.env.MODE === 'development' && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
  try {
    if (auth) { connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true }); console.log('✓ Firebase Auth Emulator connected'); }
    if (db) { connectFirestoreEmulator(db, 'localhost', 8080); console.log('✓ Firebase Firestore Emulator connected'); }
    if (storage) { connectStorageEmulator(storage, 'localhost', 9199); console.log('✓ Firebase Storage Emulator connected'); }
  } catch {
    // Emulator already connected or unavailable
  }
}

export { app, auth, db, storage, analytics };
